export default class Pricing {
	constructor(block) {
		this.block = block;

		if (!this.block) {
			return;
		}

		this.changable = this.block.querySelectorAll(".changable");
		this.activeButton = null;

		const firstButton = this.block.querySelector("button");

		if (firstButton) {
			this.activateButton(firstButton);
		}

		this.block.addEventListener("click", this.handlePriceClick.bind(this));
	}

	activateButton(button) {
		if (this.activeButton) {
			if (this.activeButton.isSameNode(button.target)) {
				return;
			}

			this.activeButton.classList.remove("active");
		}

		const className = button.dataset.plan;

		for (const item of this.changable) {
			if (item.classList.contains(className)) {
				item.classList.add("active");
			} else {
				item.classList.remove("active");
			}
		}

		this.activeButton = button;
		this.activeButton.classList.add("active");
	}

	handlePriceClick(e) {
		if (e.target.tagName === "BUTTON") {
			this.activateButton(e.target);
		}
	}
}
